import {wowInit} from "./wow";
import {initDrawOut} from "./drawOut";

export function dealWithFiltering() {
    const portfolioProjects = document.getElementById("portfolioProjectRow");
    if (portfolioProjects) {
        portfolioProjects.scrollIntoView({
                behavior: 'instant'
            })
    } else {
        wowInit()
        initDrawOut()
    }
}